// To distinguish between server side / pre rendering and client side rendering
export const isClient = typeof window !== 'undefined';
